module.exports = __webpack_public_path__ + "static/media/arrow_btn.3f033cd9.svg";